import { useEffect, useRef, useState } from 'react';
import { isDesktopViewport } from '../constants/layout';

export function useResponsiveSidebar() {
  const initialDesktop = isDesktopViewport();
  const [isDesktop, setIsDesktop] = useState<boolean>(initialDesktop);
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(initialDesktop);
  const viewportStatusRef = useRef(initialDesktop);

  useEffect(() => {
    function handleResize() {
      setIsDesktop(isDesktopViewport());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (viewportStatusRef.current === isDesktop) {
      return;
    }
    viewportStatusRef.current = isDesktop;
    setSidebarOpen(isDesktop);
  }, [isDesktop]);

  return { isDesktop, sidebarOpen, setSidebarOpen };
}
